import { createFileRoute } from "@tanstack/react-router"
import DesignSystemTextInput from "~/pages/design-system/components/TextInput"

export const Route = createFileRoute("/_auth/internal/design-system/components/text-input")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemTextInput />
}
